import  secureLocalStorage  from  "react-secure-storage";
import axios from "axios";

const hasProDocsAccess = async () => {
    const apiURL = `${process.env.GATSBY_API_BASE_URL}scopes/checkProdocsAccess`;
    const clientID = JSON.parse(secureLocalStorage.getItem("client_data")).client_id;
    const formBody = `json=${encodeURIComponent(JSON.stringify({ client_id: clientID }))}`;

    try {
        const response = await axios.post(apiURL, formBody, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "x-api-key": process.env.GATSBY_PRODOCS_ACCESS_API_KEY
            }
        });

        return response.data;
    } catch(error) {
        console.log("checkProdocsAccess", error.message);
        return null;
    }
};

export default hasProDocsAccess;